// import storeCostingInfo from './storeCostingInfo';
// import triggerLoginAction from './triggerLoginAction';

import { AppConfig } from '../../../app-config'
import { GCM_SIGNUP_FAILS } from '../../../components/gcm/Constants'
import getCost from '../../../utils/actions/getCost'
import { getLeadSource } from '../../../utils/analytics/leadSourceHelper'
import { triggerSimpleAjax } from '../../../utils/http-helper'
import { triggerSignup } from '../../auth/actions/signupUtils'

/**
 * Used to trigger the get cost action
 * @param {*} itineraryInfo
 * @param {*} user_details
 * @param {*} history
 * @param {*} lastLocation
 * @param {*} match
 * @param {*} configObj
 * @param {*} actions
 */
function triggerPackageGetCost({
	lastLocation = {},
	costingConfig = {},
	passengerDetail = {},
	query = {},
	router,
	flightsBookedByUserAlready = false,
	locale,
	userDetails,
	appDispatch,
	gcmDispatch,
	setVisible,
	setModalState,
}) {
	// const {
	//   itineraryInfo = { itinerary: {} },
	//   packages = {}
	// } = store.getState().app;
	// const { itinerary = { title: '' } } = itineraryInfo;
	// const { title = '', regionCode } = itinerary;
	const isUserExist = userDetails && userDetails.loggedIn
	// const { campaignDetails = {} } = packages || {};
	const { itineraryId, rc } = query

	const leadSourceData = getLeadSource({
		router,
		lastLocation,
	})

	const assignAndCost = () => {
		triggerSimpleAjax({
			url: `${AppConfig.api_url}itinerary/campaign/${itineraryId}/assignUser`,
			method: 'POST',
			body: { leadSource: leadSourceData },
			onSuccess: response => {
				if (response.status === 'SUCCESS') {
					getCost({
						itineraryId: response.data,
						// history,
						// lastLocation,
						req_data: {
							costingConfig,
							flightsBookedByUserAlready: flightsBookedByUserAlready,
							itineraryId: response.data,
							costingType: 'RECOST',
							// name: title
						},
						campaign: true,
						regionCode: rc,
						router,
						setVisible,
						setModalState,
					})
				}
			},
			onFailure: () => {},
		})
	}

	/**
	 * Updated user costing details in local storage
	 */
	// storeCostingInfo(costingConfig);

	/**
	 * I have used to store get the redux state of the itinerary info instead of getting args
	 * @author Jothisankar <jothi@pickyourtrail.com>
	 */
	if (isUserExist) {
		// trackGCMEvent(costingConfig, true, campaignDetails);
		assignAndCost()
	} else {
		const { name, email, mobileNumber, countryPhoneCode } =
			passengerDetail || {}
		let reqObj = {
			countryPhoneCode,
			mobileNumber,
			userName: name,
			email,
			cpid: sessionStorage && sessionStorage.getItem('campaignId'),
			leadSource: leadSourceData,
			canSendWhatsAppMessages: true,
		}

		triggerSignup({
			reqObj,
			signupType: 'SIGNUP',
			leadSource: reqObj.leadSource,
			successSubmitCallback: () => {
				assignAndCost()
			},
			dispatch: appDispatch,
			failureSubmitCallback: error => {
				if (
					error.status === 'MOBILE_EXISTS' ||
					error.status === 'EMAIL_EXISTS'
				) {
					const noteMessage =
						error.message ||
						'This mobile number is already registered with a different email ID to which the vouchers will be shared to. Please check the account details section after logging in.'

					let defaultState = {
						status: error.status,
						noteMessage,
						alreadyExist: true,
					}

					if (error.status === 'MOBILE_EXISTS') {
						defaultState = {
							...defaultState,
							defaulMobileNumber: `${mobileNumber}`,
							defaultCountryPhoneCode: countryPhoneCode,
						}
					} else {
						defaultState = {
							...defaultState,
							defaultEmail: email,
						}
					}

					gcmDispatch &&
						gcmDispatch({
							type: GCM_SIGNUP_FAILS,
							payload: {
								...defaultState,
							},
						})
					// triggerLoginAction({
					//   itineraryId,
					//   history,
					//   regionCode,
					//   campaign: true,
					//   costingConfig: {
					//     ...costingConfig,
					//     name: title,
					//     itineraryId,
					//     costingType: 'RECOST',
					//     flightsBookedByUserAlready
					//   },
					//   isFlightBookedByUser: flightsBookedByUserAlready,
					//   preState: {
					//     ...defaultState
					//   }
					// })
				} else {
					// onSignUpFail({
					//   match,
					//   passengerDetail,
					//   dealDetails,
					//   itineraryId,
					//   history,
					//   screenName: 'signup',
					//   emailAlreadyExist:
					//     typeof error.email === 'string' ? error.email : ''
					// });
				}
			},
		}).catch(() => {})
	}
}

export default triggerPackageGetCost
